var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgentMapColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 2977,
    viewBox: "0 0 32 2977",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_42078",
    "data-name": "Group 42078",
    transform: "translate(0 -31.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15830",
    "data-name": "Rectangle 15830",
    width: 32,
    height: 2976,
    transform: "translate(0 32)",
    fill: "#ebebed"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3228",
    "data-name": "Line 3228",
    x2: 32,
    transform: "translate(0 3008)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3227",
    "data-name": "Line 3227",
    x2: 32,
    transform: "translate(0 2976)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3226",
    "data-name": "Line 3226",
    x2: 32,
    transform: "translate(0 2944)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3225",
    "data-name": "Line 3225",
    x2: 32,
    transform: "translate(0 2912)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3224",
    "data-name": "Line 3224",
    x2: 32,
    transform: "translate(0 2880)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3223",
    "data-name": "Line 3223",
    x2: 32,
    transform: "translate(0 2848)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3222",
    "data-name": "Line 3222",
    x2: 32,
    transform: "translate(0 2816)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3221",
    "data-name": "Line 3221",
    x2: 32,
    transform: "translate(0 2784)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3220",
    "data-name": "Line 3220",
    x2: 32,
    transform: "translate(0 2752)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3219",
    "data-name": "Line 3219",
    x2: 32,
    transform: "translate(0 2720)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3218",
    "data-name": "Line 3218",
    x2: 32,
    transform: "translate(0 2688)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3217",
    "data-name": "Line 3217",
    x2: 32,
    transform: "translate(0 2656)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3216",
    "data-name": "Line 3216",
    x2: 32,
    transform: "translate(0 2624)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3215",
    "data-name": "Line 3215",
    x2: 32,
    transform: "translate(0 2592)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3214",
    "data-name": "Line 3214",
    x2: 32,
    transform: "translate(0 2560)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3213",
    "data-name": "Line 3213",
    x2: 32,
    transform: "translate(0 2528)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3212",
    "data-name": "Line 3212",
    x2: 32,
    transform: "translate(0 2496)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3211",
    "data-name": "Line 3211",
    x2: 32,
    transform: "translate(0 2464)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3210",
    "data-name": "Line 3210",
    x2: 32,
    transform: "translate(0 2432)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3209",
    "data-name": "Line 3209",
    x2: 32,
    transform: "translate(0 2400)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3208",
    "data-name": "Line 3208",
    x2: 32,
    transform: "translate(0 2368)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3207",
    "data-name": "Line 3207",
    x2: 32,
    transform: "translate(0 2336)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3206",
    "data-name": "Line 3206",
    x2: 32,
    transform: "translate(0 2304)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3205",
    "data-name": "Line 3205",
    x2: 32,
    transform: "translate(0 2272)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3204",
    "data-name": "Line 3204",
    x2: 32,
    transform: "translate(0 2240)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3203",
    "data-name": "Line 3203",
    x2: 32,
    transform: "translate(0 2208)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3202",
    "data-name": "Line 3202",
    x2: 32,
    transform: "translate(0 2176)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3201",
    "data-name": "Line 3201",
    x2: 32,
    transform: "translate(0 2144)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3200",
    "data-name": "Line 3200",
    x2: 32,
    transform: "translate(0 2112)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3199",
    "data-name": "Line 3199",
    x2: 32,
    transform: "translate(0 2080)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3198",
    "data-name": "Line 3198",
    x2: 32,
    transform: "translate(0 2048)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3197",
    "data-name": "Line 3197",
    x2: 32,
    transform: "translate(0 2016)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3196",
    "data-name": "Line 3196",
    x2: 32,
    transform: "translate(0 1984)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3195",
    "data-name": "Line 3195",
    x2: 32,
    transform: "translate(0 1952)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3194",
    "data-name": "Line 3194",
    x2: 32,
    transform: "translate(0 1920)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3193",
    "data-name": "Line 3193",
    x2: 32,
    transform: "translate(0 1888)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3192",
    "data-name": "Line 3192",
    x2: 32,
    transform: "translate(0 1856)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3191",
    "data-name": "Line 3191",
    x2: 32,
    transform: "translate(0 1824)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3190",
    "data-name": "Line 3190",
    x2: 32,
    transform: "translate(0 1792)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3189",
    "data-name": "Line 3189",
    x2: 32,
    transform: "translate(0 1760)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3188",
    "data-name": "Line 3188",
    x2: 32,
    transform: "translate(0 1728)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3187",
    "data-name": "Line 3187",
    x2: 32,
    transform: "translate(0 1696)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3186",
    "data-name": "Line 3186",
    x2: 32,
    transform: "translate(0 1664)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3185",
    "data-name": "Line 3185",
    x2: 32,
    transform: "translate(0 1632)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3184",
    "data-name": "Line 3184",
    x2: 32,
    transform: "translate(0 1600)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3183",
    "data-name": "Line 3183",
    x2: 32,
    transform: "translate(0 1568)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3182",
    "data-name": "Line 3182",
    x2: 32,
    transform: "translate(0 1536)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3181",
    "data-name": "Line 3181",
    x2: 32,
    transform: "translate(0 1504)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3180",
    "data-name": "Line 3180",
    x2: 32,
    transform: "translate(0 1472)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3179",
    "data-name": "Line 3179",
    x2: 32,
    transform: "translate(0 1440)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3178",
    "data-name": "Line 3178",
    x2: 32,
    transform: "translate(0 1408)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3177",
    "data-name": "Line 3177",
    x2: 32,
    transform: "translate(0 1376)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3176",
    "data-name": "Line 3176",
    x2: 32,
    transform: "translate(0 1344)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3175",
    "data-name": "Line 3175",
    x2: 32,
    transform: "translate(0 1312)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3174",
    "data-name": "Line 3174",
    x2: 32,
    transform: "translate(0 1280)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3173",
    "data-name": "Line 3173",
    x2: 32,
    transform: "translate(0 1248)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3172",
    "data-name": "Line 3172",
    x2: 32,
    transform: "translate(0 1216)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3171",
    "data-name": "Line 3171",
    x2: 32,
    transform: "translate(0 1184)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3170",
    "data-name": "Line 3170",
    x2: 32,
    transform: "translate(0 1152)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3169",
    "data-name": "Line 3169",
    x2: 32,
    transform: "translate(0 1120)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3168",
    "data-name": "Line 3168",
    x2: 32,
    transform: "translate(0 1088)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3167",
    "data-name": "Line 3167",
    x2: 32,
    transform: "translate(0 1056)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3166",
    "data-name": "Line 3166",
    x2: 32,
    transform: "translate(0 1024)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3165",
    "data-name": "Line 3165",
    x2: 32,
    transform: "translate(0 992)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3164",
    "data-name": "Line 3164",
    x2: 32,
    transform: "translate(0 960)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3163",
    "data-name": "Line 3163",
    x2: 32,
    transform: "translate(0 928)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3162",
    "data-name": "Line 3162",
    x2: 32,
    transform: "translate(0 896)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3161",
    "data-name": "Line 3161",
    x2: 32,
    transform: "translate(0 864)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3160",
    "data-name": "Line 3160",
    x2: 32,
    transform: "translate(0 832)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3159",
    "data-name": "Line 3159",
    x2: 32,
    transform: "translate(0 800)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3158",
    "data-name": "Line 3158",
    x2: 32,
    transform: "translate(0 768)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3157",
    "data-name": "Line 3157",
    x2: 32,
    transform: "translate(0 736)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3156",
    "data-name": "Line 3156",
    x2: 32,
    transform: "translate(0 704)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3155",
    "data-name": "Line 3155",
    x2: 32,
    transform: "translate(0 672)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3154",
    "data-name": "Line 3154",
    x2: 32,
    transform: "translate(0 640)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3153",
    "data-name": "Line 3153",
    x2: 32,
    transform: "translate(0 608)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3152",
    "data-name": "Line 3152",
    x2: 32,
    transform: "translate(0 576)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3151",
    "data-name": "Line 3151",
    x2: 32,
    transform: "translate(0 544)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3150",
    "data-name": "Line 3150",
    x2: 32,
    transform: "translate(0 512)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3149",
    "data-name": "Line 3149",
    x2: 32,
    transform: "translate(0 480)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3148",
    "data-name": "Line 3148",
    x2: 32,
    transform: "translate(0 448)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3147",
    "data-name": "Line 3147",
    x2: 32,
    transform: "translate(0 416)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3146",
    "data-name": "Line 3146",
    x2: 32,
    transform: "translate(0 384)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3145",
    "data-name": "Line 3145",
    x2: 32,
    transform: "translate(0 352)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3144",
    "data-name": "Line 3144",
    x2: 32,
    transform: "translate(0 320)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3143",
    "data-name": "Line 3143",
    x2: 32,
    transform: "translate(0 288)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3142",
    "data-name": "Line 3142",
    x2: 32,
    transform: "translate(0 256)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3141",
    "data-name": "Line 3141",
    x2: 32,
    transform: "translate(0 224)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3140",
    "data-name": "Line 3140",
    x2: 32,
    transform: "translate(0 192)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3139",
    "data-name": "Line 3139",
    x2: 32,
    transform: "translate(0 160)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3138",
    "data-name": "Line 3138",
    x2: 32,
    transform: "translate(0 128)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3137",
    "data-name": "Line 3137",
    x2: 32,
    transform: "translate(0 96)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3136",
    "data-name": "Line 3136",
    x2: 32,
    transform: "translate(0 64)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3135",
    "data-name": "Line 3135",
    x2: 32,
    transform: "translate(0 32)",
    fill: "none",
    stroke: "#d4d8de",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentMapColumn);
export default __webpack_public_path__ + "static/media/agent-map-column.b093f75ff7371b341a1b03b32ab53b72.svg";
export { ForwardRef as ReactComponent };